import { gql } from '@apollo/client'

export const USER_BULK_FOLLOW_SERIES = gql`
  mutation userBulkFollowSeries($seriesIds: [String!]!) {
    userBulkFollowSeries(seriesIds: $seriesIds)
  }
`
